import { createBrowserRouter, Navigate } from 'react-router';

import { Auth0Guard } from '@anyx/common-auth';
import { FALLBACK_ROUTE } from '@anyx/common-routing';
import { AccountFunctionRoutes } from '@anyx/function-account';
import { ChatFunctionRoutes } from '@anyx/function-chat';
import { LogisticFunctionRoutes } from '@anyx/function-logistic';
import { MarketplaceFunctionRoutes } from '@anyx/function-marketplace';
import { PolicyModuleRoutes } from '@anyx/function-policy';
import { ReportFunctionRoutes } from '@anyx/function-report';
import { ShippingFunctionRoutes } from '@anyx/function-shipping';
import { WorkflowFunctionRoutes } from '@anyx/function-workflow';
import { Spinner } from '@anyx/shared-ui';

import { App } from './app';
import { ErrorModuleRoutes } from './modules/errors';
import { ErrorNotFoundPage } from './modules/errors/pages';
import { HomeModuleRoutes } from './modules/home';
import { IndexPage } from './modules/index';
import { OnboardingModuleRoutes } from './modules/onboarding';
import { ShopeeAuthorizationModuleRoutes } from './modules/shopee-authorization';

export const getRouter = () => {
  return createBrowserRouter([
    // Outside the `<App />` route on purpose: these render for visitors with no AnyX account, so
    // they must not mount the app shell or its providers. See the module's routing file (anyx#1705).
    ...ShopeeAuthorizationModuleRoutes,
    {
      path: ':workspaceMasterStoreDataId?/',
      element: <App />,
      errorElement: <ErrorNotFoundPage />,
      hydrateFallbackElement: <Spinner />,
      children: [
        {
          index: true,
          element: (
            <Auth0Guard>
              <IndexPage />
            </Auth0Guard>
          ),
        },
        ...AccountFunctionRoutes,
        ...ChatFunctionRoutes,
        ...HomeModuleRoutes,
        ...LogisticFunctionRoutes,
        ...MarketplaceFunctionRoutes,
        ...OnboardingModuleRoutes,
        ...ReportFunctionRoutes,
        ...ShippingFunctionRoutes,
        ...WorkflowFunctionRoutes,
        ...PolicyModuleRoutes,
        ...ErrorModuleRoutes,
        {
          path: '*',
          element: <Navigate to={FALLBACK_ROUTE} replace={true} />,
        },
      ],
    },
  ]);
};
